import React from 'react';
import './ReceiptSidebar.css';

function ReceiptSidebar({ activeView, onViewChange }) {
  const menuItems = [
    {
      id: 'dashboard',
      label: 'Receipt Dashboard',
      icon: '📊',
      description: 'View and manage all receipts'
    },
    {
      id: 'submit',
      label: 'Submit Receipt',
      icon: '📤',
      description: 'Upload new receipt'
    },
    {
      id: 'staff',
      label: 'Support Staff Registry',
      icon: '👥',
      description: 'Manage staff members'
    }
  ];

  return (
    <aside className="receipt-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-icon">🧾</div>
        <h2>Receipt System</h2>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`sidebar-item ${activeView === item.id ? 'active' : ''}`}
            onClick={() => onViewChange(item.id)}
          >
            <div className="sidebar-item-icon">{item.icon}</div>
            <div className="sidebar-item-content">
              <div className="sidebar-item-label">{item.label}</div>
              <div className="sidebar-item-description">{item.description}</div>
            </div>
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-info">
          <small>Receipt Management System</small>
          <small>v1.0.0</small>
        </div>
      </div>
    </aside>
  );
}

export default ReceiptSidebar;

